import styled from "@emotion/styled";

export const Container = styled.div`
  height: 140px;
  width: 416px;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 21px;
  z-index: 2;
`;
